import './App.css';
import { SmokeBackground } from "./components/ui/spooky-smoke-animation";
import { LinktreeCard } from "./components/ui/linktree-card";

function App() {
  return (
    <main className="relative isolate w-full min-h-[100dvh] bg-gray-900 overflow-hidden">
      <SmokeBackground smokeColor="#15B2AF" />
      <LinktreeCard />
    </main>
  );
}

export default App;
